import { render, staticRenderFns } from "./FilaAtendimento.vue?vue&type=template&id=7adf0bc0&"
import script from "./FilaAtendimento.vue?vue&type=script&lang=js&"
export * from "./FilaAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./FilaAtendimento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7adf0bc0')) {
      api.createRecord('7adf0bc0', component.options)
    } else {
      api.reload('7adf0bc0', component.options)
    }
    module.hot.accept("./FilaAtendimento.vue?vue&type=template&id=7adf0bc0&", function () {
      api.rerender('7adf0bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lista-vez/FilaAtendimento.vue"
export default component.exports